/* import __COLOCATED_TEMPLATE__ from './human-support.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();